import { render, staticRenderFns } from "./ClaimsLitigationWork.vue?vue&type=template&id=6610b396&"
import script from "./ClaimsLitigationWork.vue?vue&type=script&lang=js&"
export * from "./ClaimsLitigationWork.vue?vue&type=script&lang=js&"
import style0 from "./ClaimsLitigationWork.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports